const robotsFieldOptions = [
  'noindex',
  'nofollow',
  'index',
  'follow',
  'all',
  'noarchive',
  'nosnippet',
  'noodp',
  'notranslate',
  'noimageindex',
  'none',
  'max-image-preview:large',
];

export default {
  robotsFieldOptions,
};
